import { useEffect } from 'react';
import { TRIP_LOCKED_EVENT } from '@/app/api/client';
import { toast } from '@/app/components/shared/toastStore';

/**
 * Shows a Trip Pass trip's refusal once it has ended (JAR-1860), over whichever
 * screen made the write: the client raises TRIP_LOCKED_EVENT with core's
 * sentence, which says the journal is still open and what reopens the trip.
 * The toast store keeps one copy of the same words on screen, so a screen that
 * reports the refusal in core's words too, or several of its saves, adds none.
 */
export function useTripLockedToast(): void {
  useEffect(() => {
    const onLocked = (e: Event) => {
      // Only the client raises this, always with core's sentence. An event
      // without one would otherwise show an empty toast.
      const message = (e as CustomEvent<string>).detail;
      if (message) toast.error(message);
    };
    window.addEventListener(TRIP_LOCKED_EVENT, onLocked);
    return () => window.removeEventListener(TRIP_LOCKED_EVENT, onLocked);
  }, []);
}
